const inputElement = $('.autocomplete-okres');
const parentElement = $('.autocomplete-box');
const paramClass = 'autocomplete-var';

inputElement.typeahead({
        hint: true,
        highlight: true,
        minLength: 2
    },
    {
        displayKey: 'token',
        name: 'okresy',
        source: function (query, syncResults, asyncResults) {
            var results = [];
            $.ajax({
                type: 'GET',
                //url: '/ajax.html',
                url: '/projekty-rodinnych-domu/ajax/',
                data: {
                    'maxRows': 12,
                    'searchStartsWith': query,
                    '_do': 'getokresy'
                },
                success: function (ret) {
                    if (ret.status === true) {
                        for (i in ret.results) {
                            results.push(ret.results[i]);
                        }
                        //console.log(results);
                        asyncResults(results);
                    } else {
                        asyncResults(results);
                    }
                }
            });
        },
        templates: {
            //empty: ['Žádný výsledek'].join('\n'),
            suggestion: function (e) {
                return '<div>' + e.label + '</div>';
            }
        },
        limit: 12
    });

inputElement.bind('typeahead:select', function (ev, suggestion) {
    let autocomplete_var = document.getElementsByName('okres_kod')[0];
    console.log(autocomplete_var);

    autocomplete_var.value=suggestion.paramValue;
    autocomplete_var.dataset.txtraw = suggestion.token;

    let okres_kod_error = document.getElementById('okres_kod-error');
    if(okres_kod_error!=="undefined" && okres_kod_error!==null) { okres_kod_error.remove(); }

    // let appendInput = document.createElement('input');
    // appendInput.type = 'hidden';
    // appendInput.name = suggestion.paramName;
    // appendInput.value = suggestion.paramValue;
    // appendInput.dataset.txtraw = suggestion.token;
    // appendInput.className = paramClass;
    //
    // parentElement.append(appendInput);
});

inputElement.bind('typeahead:render', function (ev, suggestion) {
    let paramElement = $('.'+paramClass,parentElement);
    if(paramElement.length>0) {
        if(paramElement.data('txtraw')!==inputElement.val()) {
            //paramElement.remove();
            paramElement.val('');
        }
    }
});

$("#td-open-gallery").on("click",function(){
    $.fancybox.open(tdfoto,{
        buttons:["close"]
    });
    return false
});

// inputElement.bind('typeahead:active',function (ev, suggestion) {
//     console.log('active');
// });
// inputElement.bind('typeahead:idle',function (ev, suggestion) {
//     console.log('idle');
// });
// inputElement.bind('typeahead:open',function (ev, suggestion) {
//     console.log('open');
// });
// inputElement.bind('typeahead:close',function (ev, suggestion) {
//     console.log('close');
// });
// inputElement.bind('typeahead:change',function (ev, suggestion) {
//     console.log('change');
// });
// inputElement.bind('typeahead:render',function (ev, suggestion) {
//     console.log('render');
// });
// inputElement.bind('typeahead:autocomplete',function (ev, suggestion) {
//     console.log('autocomplete');
// });
// inputElement.bind('typeahead:cursorchange',function (ev, suggestion) {
//     console.log('cursorchange');
// });
// inputElement.bind('typeahead:asyncrequest',function (ev, suggestion) {
//     console.log('asyncrequest');
// });
// inputElement.bind('typeahead:asynccancel',function (ev, suggestion) {
//     console.log('asynccancel');
// });
// inputElement.bind('typeahead:asyncreceive',function (ev, suggestion) {
//     console.log('asyncreceive');
// });
